<script lang="ts">
	import {
		ActionsContainer,
		AdvancedCard,
		IconButton,
		LabelList,
		Text,
		Toggle,
	} from '@Shelly/shelly-design-system/index';
	import { format } from 'svelte-i18n';
	import type { CameraZone } from '../../types/camera-zones';
	import { createEventDispatcher } from 'svelte';
	import { getZoneId, isDefaultZone } from '../../helpers/camera-zone-helpers';
	import { rgbToCss } from 'src/helpers/utilities';

	export let zone_component: string;
	export let zone_status;
	export let zone_settings: CameraZone;
	export let disableToggle: boolean = false;

	$: zone_id = getZoneId(zone_component);
	$: isPrivacy = zone_settings?.type === 'privacy';

	const dispatcher = createEventDispatcher();
</script>

<AdvancedCard
	class="mt-s"
	leftSlotBackground
	title={zone_settings?.name || $format('text_zone', { default: 'Zone' })}
	aria-labelledby={zone_settings?.name || $format('text_zone', { default: 'Zone' })}
>
	<Toggle
		aria-label={$format('toggle_zone', { default: 'Toggle zone' })}
		slot="left"
		size="m"
		checked={zone_settings.enable}
		disabled={disableToggle}
		on:click={() => {
			dispatcher('enable', { zone_id, enable: !zone_settings.enable });
		}}
		id="toggle-1nnzt8m"
	/>
	<div slot="title">
		<Text styleType="body-small" class="text-600 mb-xs">
			{zone_settings?.name || $format('text_zone', { default: 'Zone' })}
		</Text>
	</div>
	<LabelList
		size="m"
		labelList={[
			{
				icon: 'fa-duotone fa-light fa-circle',
				iconStyle: `--fa-primary-color: var(--color-white); --fa-secondary-color: ${rgbToCss(zone_settings?.color, 1)}; --fa-secondary-opacity: 1`,
			},
			...(!isPrivacy
				? [
						{
							value: zone_status?.motion
								? $format('status_motion', { default: 'Motion' })
								: $format('status_no_motion', { default: 'No motion' }),
							icon: zone_status?.motion ? 'fas fa-running' : 'fas fa-person',
						},
					]
				: []),
		]}
		slot="main"
		data-prevent-drawer-swipe
		data-prevent-sidepanel-swipe
	/>
	<ActionsContainer orientation="vertical" type="simple" slot="right">
		<IconButton
			aria-label={$format('button_edit', {
				default: 'Button edit',
			})}
			variant="primary"
			icon="fas fa-pen"
			slot="first"
			on:click={() => dispatcher('edit', { zone_id, zone_settings })}
		/>
		<IconButton
			aria-label={$format('button_delete', {
				default: 'Button delete',
			})}
			icon="fas fa-trash"
			variant="danger"
			slot="second"
			disabled={isDefaultZone(zone_id)}
			on:click={() => dispatcher('delete', { zone_id })}
		/>
	</ActionsContainer>
</AdvancedCard>
